import { ChangeDetectionStrategy, Component, inject, Injector, Input } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AbstractTuiControl } from '@taiga-ui/legacy';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfirmComponent } from '@src/app/shared/dialogs';

import { LoyaltyProgramProductAddress } from '../loyalty-program/models';

import { GeocoderDialogComponent } from './components';

@Component({
  selector: 'app-geocoder',
  templateUrl: './geocoder.component.html',
  styleUrls: ['./geocoder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeocoderComponent extends AbstractTuiControl<Array<LoyaltyProgramProductAddress>> {
  @Input() title: string = '';

  private destroyed$$ = new Subject<void>();

  private readonly dialogService = inject(TuiDialogService);
  private readonly translateService = inject(TranslateService);
  private readonly injector = inject(Injector);

  private readonly confirmDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.geocoder.dialogs.clearAllData'),
      size: 's',
      closeable: false,
    },
  );

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): Array<LoyaltyProgramProductAddress> {
    return [];
  }

  ngOnDestroy(): void {
    this.destroyed$$.next();
    this.destroyed$$.complete();
  }

  openMultipleInputDialog() {
    this.dialogService
      .open<string[] | undefined>(new PolymorpheusComponent(GeocoderDialogComponent, this.injector), {
        label: this.translateService.instant('components.geocoder.dialogs.multipleInputHeader'),
      })
      .subscribe(resArray => {
        if (resArray?.length) {
          const formattedResult = resArray.map(address => {
            return <LoyaltyProgramProductAddress>{ address };
          });
          this.value = this.value.concat(formattedResult);
        }
      });
  }

  deleteAllData() {
    this.confirmDialog.pipe(takeUntil(this.destroyed$$)).subscribe({
      next: res => {
        if (res) {
          this.value = [];
        }
      },
    });
  }
}
